import { useState } from "react";
import {
  Box,
  Button,
  ButtonOwnProps,
  Dialog,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
} from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";

import conf from "config-dlm";

const JsonModal = ({
  label = "View",
  data,
  type,
  title,
  typeTitle,
  color = "primary",
}: {
  label?: string;
  data: any;
  type: string;
  title: string;
  typeTitle?: string;
  color?: ButtonOwnProps["color"];
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        size="small"
        color={color}
        variant="contained"
        onClick={handleOpen}
      >
        {label}
      </Button>

      <Dialog fullWidth maxWidth="lg" onClose={handleClose} open={open}>
        <Box sx={conf.STYLE.JSON}>
          <Grid container spacing={0}>
            <Grid item xs={7}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <StorageIcon color="secondary" />
                <DialogTitle align="left" sx={{ padding: 0 }}>
                  <b>{title.toUpperCase()}</b>
                </DialogTitle>
              </Stack>
            </Grid>

            <Grid item xs={5} alignSelf="center">
              <DialogContentText align="right">
                {typeTitle ? <i>{typeTitle}</i>  :  <i>* raw {type.toUpperCase()} output</i>}
              </DialogContentText>
            </Grid>
          </Grid>

          <pre style={{ overflowX: "auto", wordWrap: "break-word" }}>
            {JSON.stringify(data, null, 4)}
          </pre>
        </Box>
      </Dialog>
    </div>
  );
};

export default JsonModal;
